// extracted by mini-css-extract-plugin
export default {"inputContainer":"styles_inputContainer__pp4aX","error":"styles_error__85YNM","forgotPassword":"styles_forgotPassword__u2JvC"};